<template>
  <div
    class="file-uploader"
    :class="classes"
  >
    <div class="button-container">
      <!-- <button type="button" class="primary-btn btn upload-btn">
                <img :src="url('/img/icons/upload.svg')" alt="Nahrať fotografiu" class="upload-icon">
                {{ buttonText }}
            </button> -->
      <input
        v-if="multiple"
        :id="name"
        multiple
        type="file"
        :name="name"
        :accept="accept"
        @change="changeInput"
      >
      <input
        v-else
        :id="name"
        type="file"
        :name="name"
        :accept="accept"
        @change="changeInput"
      >
    </div>
  </div>
</template>
<script>
import { i18n } from '../../../../i18n'
import { url } from '../../../../helpers'
import useFileUploader from './useFileUploader'
import store from '../../../store'

export default {
  props: {
    multiple: {
      type: Boolean,
      default: () => false,
    },
    countLimit: {
      type: Number,
      default: () => 1,
    },
    sizeLimit: {
      type: Number,
      default: () => 15,
    },
    classes: {
      type: String,
      default: () => '',
    },
    id: {
      type: String,
      default: () => 'file',
    },
    name: {
      type: String,
      default: () => 'originalFile',
    },
    accept: {
      type: String,
      default: () => '.jpg,.jpeg,image/*', // images
    },
    text: {
      type: String,
    },
    storeNamespace: {
      type: String,
      default: () => 'fileUploader/',
    },
  },
  setup(props) {
    const {
      t,
    } = i18n.global
    const {
      handleFiles,
    } = useFileUploader()

    store.commit(`${props.storeNamespace}SET_SIZE_LIMIT`, props.sizeLimit)
    store.commit(`${props.storeNamespace}SET_COUNT_LIMIT`, props.countLimit)
    store.commit(`${props.storeNamespace}SET_MULTIPLE`, props.multiple)

    return {
      url,
      handleFiles,
      t,
    }
  },
  computed: {
    buttonText() {
      return this.text || this.t('Upload image')
    },
  },
  methods: {
    changeInput(event) {
      if (this.handleFiles(event, this.storeNamespace)) {
        this.$emit('uploaded-file')
      }
    },
  },
}
</script>
<style lang="scss">
.button-container {
    position: relative;

    input {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        opacity: 0;
        cursor: pointer;
    }

    button {
        padding: 18px 35px;
        margin: 15px 0 20px 0;
    }
}

@media (max-width: 575px) {
    .button-container {

        &,
        & button {
            width: 100%;
        }

        button {
            padding: 20px 35px;
        }
    }
}
</style>
